import React from 'react';
import { Storefront, Warehouse, Build, BuildCircle } from '@mui/icons-material';
import StatCard from './StatCard';
import { COLORS } from '../shared/tokens';

/* Fallback for users without a recognised group (PC_GRP_ID outside 1–4):
   a light, read-only system snapshot rather than a blank screen. */
export default function DefaultDashboard({ data }) {
    const k = (data && data.kpis) || {};
    return (
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
            <StatCard label="Shops" value={k.shops ?? 0} accent={COLORS.primary} icon={<Storefront fontSize="small" />} />
            <StatCard label="Warehouses" value={k.warehouses ?? 0} accent="#2563eb" icon={<Warehouse fontSize="small" />} />
            <StatCard label="Total Repairs" value={k.repairs ?? 0} accent="#15803d" icon={<Build fontSize="small" />} />
            <StatCard label="Jobs In Process" value={k.inProcess ?? 0} accent="#a16207" icon={<BuildCircle fontSize="small" />} />
        </div>
    );
}
